export const NotificationTypeConsts = {
  WithdrawUpdateStatus: "withdraw_status_updated",
  DepositUpdateStatus: "deposite_status_updated",
  UserProofStatusUpdate: "Proof_Status_Update",
  UserBankStatusUpdate: "Bank_Status_Update",
  UserStatusUpdate: "user_status_update",
  SendInboxMessageByAdmin: "send_inbox_message_by_admin",
  TransactionUpdate: "TransactionUpdate",
  WithdrawRevert: "withdraw_revert",
  DepositRevert: "deposit_revert"
};
